import React from 'react';
import { StarIcon } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { StarRow } from '../ui/Rating';
import { averageScores } from '../../data/reviews';
import { dateWithYear } from '../../utils/format';
import type { Review } from '../../types/chef';
export function ScoreBreakdown({
  chefId,
  rating,
  count
}: {
  chefId: string;
  rating: number;
  count: number;
}) {
  const scores = averageScores(chefId);
  return <div className="grid gap-6 sm:grid-cols-[auto_minmax(0,1fr)] sm:items-center" data-id="element-394" data-mp="2lstqzy1ryaj2">
      <div data-id="element-395" data-mp="2guij3sv1ia3h">
        <p className="flex items-baseline gap-2" data-id="element-396" data-mp="2gurzqpu734wi">
          <span className="tnum font-display text-4xl font-semibold tracking-[-0.02em] text-ink" data-id="element-397" data-mp="2usqdbt0oyxay">{rating.toFixed(1)}</span>
          <StarIcon className="h-5 w-5 fill-accent text-accent" aria-hidden="true" data-id="element-398" data-mp="2psu67kwp6pr6" />
        </p>
        <p className="mt-1 text-[13px] text-ink-2" data-id="element-399" data-mp="a1y776yr771t">{count} reviews</p>
      </div>
      <div className="space-y-1.5" data-id="element-400" data-mp="53wlsfduuvn6">
        <StarRow value={scores.food} label="Food" data-id="element-401" data-mp="52v1dkay8wss" />
        <StarRow value={scores.punctuality} label="Punctuality" data-id="element-402" data-mp="2rd2aaeixqmj1" />
        <StarRow value={scores.cleanliness} label="Cleanliness" data-id="element-403" data-mp="2rcit50140262" />
        <StarRow value={scores.communication} label="Communication" data-id="element-404" data-mp="2vdcgnsan3eyf" />
      </div>
    </div>;
}
export function ReviewList({
  reviews
}: {
  reviews: Review[];
}) {
  return <ul className="space-y-4" data-id="element-405" data-mp="35cbhiop5y6av">
      {reviews.map(review => <li key={review.id} className="rounded-xl border border-hairline bg-surface p-5" data-id="element-406" data-mp="35ah19nou72d4">
          <div className="flex items-start gap-3" data-id="element-407" data-mp="27qmbwj6wp6a4">
            <Avatar name={review.author} size="sm" data-id="element-408" data-mp="2cn4hfla298ni" />
            <div className="min-w-0 flex-1" data-id="element-409" data-mp="2cltflr06eaz1">
              <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-410" data-mp="2hmpetr9l18y4">
                <p className="text-sm font-semibold text-ink" data-id="element-411" data-mp="2mdfo3fl4pvy3">{review.author}</p>
                <p className="text-[12px] text-ink-3" data-id="element-412" data-mp="1oybh7cmeoen3">{dateWithYear(review.date)}</p>
              </div>
              <p className="text-[13px] text-ink-2" data-id="element-413" data-mp="1txemmy6asmvl">{review.occasion}</p>
            </div>
            <span className="flex items-center gap-1 text-sm" data-id="element-414" data-mp="1tv1wvyuat87z">
              <StarIcon className="h-4 w-4 fill-accent text-accent" aria-hidden="true" data-id="element-415" data-mp="1lv5mz085dnyz" />
              <span className="tnum font-semibold text-ink" data-id="element-416" data-mp="1hubz26upg963">{review.rating.toFixed(1)}</span>
            </span>
          </div>
          <p className="mt-3 text-[15px] leading-relaxed text-ink-2" data-id="element-417" data-mp="1vlqmqqzk4yjh">{review.body}</p>
          {review.reply && <div className="mt-4 rounded-lg bg-oat p-3.5" data-id="element-418" data-mp="1qprqkh7zmc8i">
              <p className="text-[12px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-419" data-mp="12ymco7llxu0u">Chef’s reply</p>
              <p className="mt-1 text-sm text-ink-2" data-id="element-420" data-mp="yxu31d8tpn41">{review.reply}</p>
            </div>}
        </li>)}
    </ul>;
}